import clsx from 'clsx';
import unescape from 'lodash/unescape';

import { Content } from '@/lib';
import styles from './Table.module.scss';
import { Row } from '../../Row';

export function Table({ withHeadings, content, fluid }: Content.WithFluid<Content.Table>) {
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <div className={styles.wrapper}>
        <table className={styles.table}>
          {withHeadings && (
            <thead>
              <tr>
                {(content[0] || []).map((heading) => (
                  // eslint-disable-next-line jsx-a11y/control-has-associated-label
                  <th key={heading} className={clsx(styles.th, 'text text-bold')} dangerouslySetInnerHTML={{ __html: unescape(heading) }} />
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {(withHeadings ? content.slice(1) : content).map((row, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr className={styles.tr} key={index.toString()}>
                {row.map((col, i) => (
                  // eslint-disable-next-line jsx-a11y/control-has-associated-label,react/no-array-index-key
                  <td key={i.toString()} className={clsx(styles.td, 'text')} dangerouslySetInnerHTML={{ __html: unescape(col) }} />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Row>
  );
}
